import { AppletHost } from '@meltwater/applet-host';
import { appletStateRegistrarName } from '@meltwater/applet-state-registrar';
import { AppletStates } from '@meltwater/applet-state-registrar/cjs/applet-states';
import { NoopAppletStateRegistrar } from '../noop-applet-state-registrar';

export class AppletElementStatePolicy {
    constructor() {
        this.appletStateRegistrarPromise = AppletHost.getInstance()
            .then(appletHost => appletHost.getRegistrar(appletStateRegistrarName))
            .then(maybeAppletStateRegistrar => {
                const appletStateRegistrar = maybeAppletStateRegistrar === null ? new NoopAppletStateRegistrar() : maybeAppletStateRegistrar;

                this.stateId = appletStateRegistrar.createStateId();
                appletStateRegistrar.setState({
                    stateId: this.stateId,
                    state: AppletStates.LOADING
                });
                return appletStateRegistrar;
            });
    }

    async applySetContentPolicy() {
        const appletStateRegistrar = await this.appletStateRegistrarPromise;
        appletStateRegistrar.setState({
            stateId: this.stateId,
            state: AppletStates.COMPLETE
        });
    }

    async applySetContentAndBannerPolicy() {
        const appletStateRegistrar = await this.appletStateRegistrarPromise;
        appletStateRegistrar.setState({
            stateId: this.stateId,
            state: AppletStates.COMPLETE
        });
    }

    async applySetPartialContentPolicy() {
        const appletStateRegistrar = await this.appletStateRegistrarPromise;
        appletStateRegistrar.setState({
            stateId: this.stateId,
            state: AppletStates.COMPLETE
        });
    }

    async applyShowLoaderPolicy() {
        const appletStateRegistrar = await this.appletStateRegistrarPromise;
        appletStateRegistrar.setState({
            stateId: this.stateId,
            state: AppletStates.LOADING
        });
    }

    async applyShowEmptyStateByStatusCodePolicy() {
        const appletStateRegistrar = await this.appletStateRegistrarPromise;
        appletStateRegistrar.setState({
            stateId: this.stateId,
            state: AppletStates.COMPLETE
        });
    }

    async applyShowEmptyStatePolicy() {
        const appletStateRegistrar = await this.appletStateRegistrarPromise;
        appletStateRegistrar.setState({
            stateId: this.stateId,
            state: AppletStates.COMPLETE
        });
    }
}